(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Simple pagination functionality
  document.addEventListener('DOMContentLoaded', () => {
    const resultsList = document.querySelector('results-list[pagination-style]');
    if (!resultsList) return;

    const paginationStyle = resultsList.getAttribute('pagination-style');

    // For numbered pagination, disable infinite scroll
    if (paginationStyle === 'numbered') {
      const paginatedListComponent = resultsList;
      if (paginatedListComponent && paginatedListComponent.infinityScrollObserver) {
        paginatedListComponent.infinityScrollObserver.disconnect();
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
